export default "__VITE_ASSET__5wWhh8Fz__"